import { WidgetControlType } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing logarithmic functions.
 * Focus: Logarithmic curve with vertical asymptote.
 */
export const LOGARITHMIC_PRESET: GraphpadWidgetConfig = {
  id: 'logarithmic',
  type: 'graphpad',
  params: {
    f: {
      type: 'logarithmic',
      params: { a: 1, b: Math.E, h: 1, k: 1 },
    },
    'f-translate': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-asymptotes': {
      type: 'asymptotes',
      params: { of: 'f' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -2, xEnd: 8, yStart: -4, yEnd: 4 },
      grid: { type: 'lines', visible: true },
      axes: true,
    },
    elements: {
      'f-asymptotes': {
        line: { label: { contentVariant: 'name', position: 'top' } },
      },
      'f-roots': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WidgetControlType.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-3, 3, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'teal',
      },
      {
        id: 'slider-b',
        type: WidgetControlType.Slider,
        label: 'b (base)',
        param: 'f.b',
        range: [0.5, 10, 0.1],
        defaultValue: Math.E,
        editable: true,
        color: 'indigo',
      },
      {
        id: 'slider-h',
        type: WidgetControlType.Slider,
        label: 'h (x-shift)',
        param: 'f.h',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-k',
        type: WidgetControlType.Slider,
        label: 'k (y-shift)',
        param: 'f.k',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
